import { useState } from "react";
import axios from "axios";
import { ShieldCheck } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "../ui/dialog";

export function InitialSetupDialog({ open, sessionId, API, currentEmail, onComplete }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState(currentEmail || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    setError("");
    if (newPassword.length < 4) {
      setError("Passwort muss mindestens 4 Zeichen haben");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwörter stimmen nicht überein");
      return;
    }
    try {
      setSaving(true);
      await axios.put(`${API}/user/initial-setup?session_id=${sessionId}`, {
        new_password: newPassword,
        email: email.trim(),
      });
      onComplete();
    } catch (err) {
      setError(err.response?.data?.detail || "Fehler beim Speichern");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-md [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-primary" weight="fill" />
            Ersteinrichtung
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Bitte ändern Sie Ihr Initial-Passwort und geben Sie Ihre E-Mail-Adresse ein.
        </p>
        <div className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label className="text-xs font-medium">Neues Passwort *</Label>
            <Input
              data-testid="initial-setup-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Neues Passwort eingeben"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-medium">Passwort bestätigen *</Label>
            <Input
              data-testid="initial-setup-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Passwort wiederholen"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-medium">E-Mail-Adresse</Label>
            <Input
              data-testid="initial-setup-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ihre@email.de"
            />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>
        <DialogFooter>
          <Button data-testid="initial-setup-save" onClick={handleSave} disabled={saving || !newPassword || !confirmPassword}>
            {saving ? (
              <><div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full mr-2" />Speichern...</>
            ) : (
              "Speichern & Fortfahren"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
